import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 26.84',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <path
      fill={fill}
      transform="translate(9.702 31.328)"
      d="M-1.2-31.328a9.451 9.451 0 0 1 4.065.8 5.9 5.9 0 0 1 2.561 2.19 5.719 5.719 0 0 1 .872 3.1v1.114a4.6 4.6 0 0 1-.483 2.153 5.6 5.6 0 0 1-1.169 1.559 23.319 23.319 0 0 1-1.838 1.485 12.993 12.993 0 0 0-2.394 2.114 3.716 3.716 0 0 0-.8 2.45v1h-3.6v-1.114A5.3 5.3 0 0 1-3-17.8a14.65 14.65 0 0 1 2.8-2.651 14.749 14.749 0 0 0 1.986-1.782 2.565 2.565 0 0 0 .65-1.745v-1a3.026 3.026 0 0 0-1.021-2.432 4.176 4.176 0 0 0-2.8-.872 4.8 4.8 0 0 0-3.378 1.1A4.314 4.314 0 0 0-6.1-24.238h-3.6a7.375 7.375 0 0 1 1.13-3.638A7.035 7.035 0 0 1-5.656-30.4a10.014 10.014 0 0 1 4.456-.928zm-.965 26.84a2.474 2.474 0 0 1-1.819-.742 2.474 2.474 0 0 1-.744-1.82 2.443 2.443 0 0 1 .761-1.819 2.492 2.492 0 0 1 1.8-.742 2.474 2.474 0 0 1 1.819.742A2.474 2.474 0 0 1 .4-7.05a2.474 2.474 0 0 1-.747 1.819 2.474 2.474 0 0 1-1.819.743z"
    />
  </svg>
);
export default SVG;
